import React from 'react';

import classNames from 'classnames';
import { useField } from 'formik';

export default function TextareaFormField({
    label,
    horizontalLayout,
    parentGridClass = 'tw-grid-cols-3',
    labelGridClass = 'tw-col-span-1',
    inputGridClass = 'tw-col-span-2',
    ...props
}) {
    const [field, meta, helpers] = useField(props);
    return horizontalLayout ? (
        <div className={parentGridClass + ' tw-grid tw-gap-4'}>
            <div className={labelGridClass}>
                <label htmlFor={props.name} className="text-input__label">
                    {label} {props.required && '*'}
                </label>
            </div>
            <div className={inputGridClass + ' tw-flex tw-flex-col tw-space-y-1.5'}>
                <textarea
                    className={classNames('text-input tw-min-h-8', {
                        'tw-border tw-border-red-500': meta.touched && meta.error,
                        'tw-border-0': !(meta.touched && meta.error),
                    })}
                    {...field}
                    {...props}
                />
                {meta.touched && meta.error ? <div className="tw-text-red-500 tw-text-sm">{meta.error}</div> : null}
            </div>
        </div>
    ) : (
        <div className="tw-flex tw-flex-col tw-space-y-1.5">
            <label htmlFor={props.name} className="text-input__label">
                {label} {props.required && '*'}
            </label>
            <textarea
                className={classNames('text-input tw-min-h-8', {
                    'tw-border tw-border-red-500': meta.touched && meta.error,
                    'tw-border-0': !(meta.touched && meta.error),
                })}
                {...field}
                {...props}
            />
            {meta.touched && meta.error ? <div className="tw-text-red-500 tw-text-sm">{meta.error}</div> : null}
        </div>
    );
}
